module.exports = __webpack_public_path__ + "media/stylesheets/images/boxil/BOXIL SaaS AWARD Summer 2024_使いやすさNo.1-7746187f81f29a9e194adf648aba0e86.png";